<template>
  <main id="subPage">
    <!-- 카테고리 -->
    <section id="category">
      <h2>요금사전결제</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">요금사전결제</p>
          <ul class="depth">
            <li><router-link to="/map" title="공영주차장">공영주차장</router-link></li>
            <li><router-link to="/prepaymentinfo" title="요금사전결제">요금사전결제</router-link></li>
            <li><router-link to="/unpaidinfo" title="미납주차요금">미납주차요금</router-link></li>
            <li><router-link to="/periodinfo" title="주차서비스">주차서비스</router-link></li>
            <li><router-link to="/noticelist" title="정보마당">정보마당</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">요금 조회/결제</p>
          <ul class="depth">
            <li><router-link to="/prepaymentinfo" title="사전결제 안내">사전결제 안내</router-link></li>
            <li><router-link to="/lookup" title="요금 조회/결제">요금 조회/결제</router-link></li>
            <!-- <li><router-link to="/advancepayment" title="주차요금 간편조회">주차요금 간편조회</router-link></li> -->
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">요금 조회/결제</h3>
        <article class="selectOpt type02">
          <dl>
            <dt>
              <h4 class="tit">차량번호 조회</h4>
              <p class="subTxt">출차 전 주차요금을 조회/결제하실 수 있습니다.</p>
            </dt>
            <dd>
              <input
                type="text"
                title="차량번호 입력"
                maxlength="10"
                placeholder="123가4567"
                v-model="carNo"
                @keyup.enter="searchCarNo"
              />
              <button type="button" class="btn dkGray" @click="searchCarNo">조회</button>
            </dd>
          </dl>
        </article>
        <article>
          <div class="scroll-table">
            <i class="v-scroll"></i>
            <div class="table vertical-table">
              <table>
                <caption>
                  차량번호 조회 테이블
                </caption>
                <thead>
                  <tr>
                    <th scope="col">차량번호</th>
                    <th scope="col">주차장</th>
                    <th scope="col">입차시간</th>
                    <th scope="col">상세내역</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="nodate" v-if="nodata">
                    <td colspan="4" v-if="isLoading"><loading-spinner></loading-spinner></td>
                    <td colspan="4" v-else>조회된 데이터가 없습니다.</td>
                  </tr>
                  <tr v-for="(prepay, index) in prepayList" :key="index">
                    <td>{{ prepay.carNo }}</td>
                    <td>
                      <span class="emphasis-view">{{ prepay.divNm }}</span>
                      {{ prepay.parkingNm }}
                    </td>
                    <td>{{ prepay.inDttm }}</td>
                    <td v-if="prepay.outDttm == null">
                      <button
                        type="button"
                        class="btn red"
                        :disabled="prepay.reqAmt === 0"
                        @click="prepayView(prepay)"
                      >사전결제</button>
                    </td>
                    <td v-else-if="prepay.prepayAmt">
                      <span class="pink bold">사전결제 완료</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <p class="info">
            결제 후 15분 안에 출차하지 않으면 주차요금이 추가 발생되며, 추가요금은 출차 시 추가로 결제하셔야 합니다.
          </p>
          <p class="info">
            차량번호를 확인 후 결제 해 주세요. 타인의 차량 결제 시 환불되지 않으니 꼭 확인하여 주십시오.
          </p>
        </article>
      </div>
    </section>

    <!-- 알럿 -->
    <alert-notmatch v-show="showModalMsgFailure">
      <template #content>
        <p>{{ msg }}</p>
        <article class="btnArea">
          <button class="btn blue" @click="closeBtn">확인</button>
        </article>
      </template>
      <template #button>
        <button class="btn closeBtn" @click="cancleBtn"><span class="hidden">닫기</span></button>
      </template>
    </alert-notmatch>
  </main>
</template>

<script>
import axios from '../../../util/axios';
import AlertNotmatch from '../../../components/Alert02.vue';
import LoadingSpinner from '../../../components/LoadingSpinner.vue';

export default {
  data() {
    return {
      showModalMsgFailure: false,
      msg: '차량번호 형식에 맞지 않습니다.',
      carNo: '',
      prepayList: [],
      nodata: true,
      isLoading: false,
    };
  },

  components: {
    AlertNotmatch,
    LoadingSpinner,
  },

  methods: {
    cancleBtn() {
      this.showModalMsgFailure = false;
    },

    closeBtn() {
      this.showModalMsgFailure = false;
    },

    validate() {
      const carNoRegex = /^([가-히]{2}){0,1}[0-9]{1,3}[가-히]{1}[0-9]{4}$/gi;
      if (!this.carNo || !carNoRegex.test(this.carNo.replace(/\s/gi, ''))) {
        this.msg = '차량번호가 형식에 맞지 않습니다.';
        this.showModalMsgFailure = true;
        return false;
      }
      return true;
    },

    async searchCarNo() {
      this.isLoading = true;
      if (!this.validate()) {
        this.isLoading = false;
        return;
      }

      const res = await axios('get', '/api/prepay/searchPrepayList.json', {
        carNo: this.carNo.replace(/\s/gi, ''),
      });

      const data = res?.data?.value?.result;
      if (!data) {
        this.prepayList = [];
        this.nodata = true;
        this.isLoading = false;
        return;
      }

      // 실시간 결제금액을 먼저 계산 후 화면에 반영
      await this.loadAmounts(data);

      this.prepayList = data;
      this.nodata = data.length === 0;
      this.isLoading = false;
    },

    // 실시간 결제금액을 조회해 0원이면 "사전결제" 버튼을 비활성화
    async loadAmounts(list) {
      const targets = list.filter((prepay) => prepay.outDttm == null);

      await Promise.all(
        targets.map(async (prepay) => {
          const res = await axios('get', '/api/prepay/view.json', {
            inOutId: prepay.inOutId,
            sectnId: prepay.sectnId,
            carNo: prepay.carNo,
            inDttm: prepay.inDttm,
            discountCd: prepay.discountCd?.discountCd ?? '',
            extraCd: prepay.extraCd?.discountCd ?? '',
            myPage: 'N',
          });

          const reqAmt = res?.data?.resultMap?.reqAmt;
          prepay.reqAmt = typeof reqAmt === 'number' ? reqAmt : -1;
        }),
      );
    },

    prepayView(prepay) {
      const params = {
        inOutId: prepay.inOutId,
        sectnId: prepay.sectnId,
        carNo: prepay.carNo,
        inDttm: prepay.inDttm,
        discountCd: prepay.discountCd?.discountCd ?? '',
        extraCd: prepay.extraCd?.discountCd ?? '',
        outDttm: prepay.outDttm,
      };
      this.$router.push({
        name: 'paymentview',
        params: { data: params },
      });
    },
  },
};
</script>
